module.exports = "<div class=\"text-center\" st-pagination=\"\" st-items-by-page=\"$ctrl.stItemsByPage\" st-template=\"pagination.custom.html\">\n</div>\n"